import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
// import { checkPrivileges } from '../../../../config/Global';

interface DataType {
  id: number;
  row_id: string;
  providers: string;
  provider_name: string;
  network_identity: number;
  // status: string;
  email: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
    handleEditModal,
    handleDeleteRequest,
  } = props;

  // const userDetails = localStorage.getItem('userDetails');
  // const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id - b.id,
      render: (_, record) => {
        return record.id;
      },
    },
    {
      title: "Providers",
      key: "providers",
      dataIndex: "providers",
      width: 100,
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.providers.localeCompare(b.providers),
    },
    {
      title: "Provider Name",
      key: "provider_name",
      dataIndex: "provider_name",
      width: 160,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.provider_name || "").localeCompare(b.provider_name || ""),
    },
    {
      title: "Email",
      key: "email",
      dataIndex: "email",
      width: 300,
      sortDirections: ["descend", "ascend"],
      // sorter: (a, b) => a.email.localeCompare(b.email),
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
      render: (_, record) => {
        return (
          <div className="longData">{record.email ?? CONSTANT.NOT_UPDATED}</div>
        );
      },
    },
    {
      title: "Network Identity",
      key: "network_identity",
      dataIndex: "network_identity",
      width: 160,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.network_identity - b.network_identity,
    },

    // {
    //   title: 'Status',
    //   key: 'status',
    //   dataIndex: 'status',
    //   width: 140,
    //   sortDirections: ['descend', 'ascend'],
    //   sorter: (a, b) => a.status.localeCompare(b.status),
    //   render: (_, record) => {
    //     return (
    //       <div className="longData">
    //         {record.status === 'in progress'
    //           ? 'In Progress'
    //           : record.status === 'completed'
    //             ? 'Completed'
    //             : CONSTANT.NOT_UPDATED}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      fixed: "right",
      // hidden: checkPrivileges(userRoles, 'admin') ? false : true,
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"Edit Provider"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleEditModal(record)}
              />
            </Tooltip>
            <Tooltip title={"Delete Provider"}>
              <Button
                type="default"
                icon={<DeleteOutlined />}
                className="cancelBtn iconBtn"
                onClick={() => handleDeleteRequest(record)}
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const providersData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    id: item.id,
    row_id: item._id,
    providers: item?.providers,
    provider_name: item.provider_name,
    email: item.email,
    network_identity: item.network_identity,
    // status: item.status,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps["onChange"] = (pageNumber, pageSize) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
    const updateData = {
      ...savePayload,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    pageNumber,
    pageSize
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
    const updateData = {
      ...savePayload,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    getList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={providersData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.pageNumber}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.pageSize}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>
    </>
  );
};
export default ListTable;
